import {Component, Input} from '@angular/core';
import {KENDO_TREEVIEW} from '@progress/kendo-angular-treeview';

import {SimpleImageComponent} from '../simple-image/simple-image.component';
import {SimpleLibelleComponent} from '../simple-libelle/simple-libelle.component';
import {DonneesTreeViewItem} from './DonneesTreeView';

//Composant tree view
@Component (
{
  selector: 'val-simple-tree-view',
  imports: 
  [
    KENDO_TREEVIEW,
    SimpleImageComponent,
    SimpleLibelleComponent
  ],
  templateUrl: './simple-tree-view.component.html',
  styleUrl: './simple-tree-view.component.scss'
})
export class SimpleTreeViewComponent 
{
  //Création
  constructor () 
  {
    this.items = [];
    this.itemsOuverts = [];
  }

  //Items
  @Input ()
  public items: DonneesTreeViewItem[];

  @Input ()
  public itemsOuverts: number[];

  //Retourne l'url de l’icone d’un item
  public RetournerIconeItem (item: DonneesTreeViewItem) : string 
  {
    let urlIcone: string;

    urlIcone = `assets/iconeRg${item.niveau}.png`;

    return urlIcone;
  }
}
